import React from 'react';
export function AboutPage() {
  return <section className="w-full bg-white text-secondary-800 text-base leading-7 font-sans rounded-xl shadow-2xl overflow-hidden" data-id="element-22">
      <div className="bg-gradient-to-br from-primary-700 via-primary-600 to-primary-800 text-white py-16 px-8 relative overflow-hidden" data-id="element-23">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-24"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-900/20 to-transparent" data-id="element-25"></div>
        <div className="relative z-10" data-id="element-26">
          <h1 className="font-display text-4xl md:text-6xl font-bold mb-6 text-center leading-tight" data-id="element-27">
            Meet Our Team
          </h1>
          <p className="text-center text-xl md:text-2xl max-w-3xl mx-auto text-primary-50 font-medium" data-id="element-28">
            The experts behind the Early Warning Report Service
          </p>
        </div>
      </div>
      <div className="px-8 py-12 max-w-5xl mx-auto" data-id="element-29">
        <div className="grid md:grid-cols-2 gap-10 mt-8" data-id="element-30">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-secondary-100 hover:shadow-2xl hover:scale-105 transition-all duration-300" data-id="element-31">
            <div className="w-full overflow-hidden flex justify-center bg-gradient-to-br from-secondary-50 to-primary-50/30 p-6" data-id="element-32">
              <img src="https://i.imgur.com/rme3gj9.jpg" alt="Raymond King" className="object-contain max-h-80 rounded-lg" data-id="element-33" />
            </div>
            <div className="p-8" data-id="element-34">
              <h3 className="font-display text-3xl font-bold text-primary-700 mb-2" data-id="element-35">
                Raymond King
              </h3>
              <p className="text-xl text-secondary-600 mb-6 font-medium" data-id="element-36">
                Principal
              </p>
              <p className="text-secondary-700 leading-relaxed" data-id="element-37">
                Raymond, or Ray, has been a noted innovator and entrepreneur
                since he started a company while still in high school. His next
                project, Semaphore, Inc., was created during his sophomore year
                at M.I.T., and began as a project management software package.
                By 1990, it was rated #1 in its space by ARCHITECTURE magazine,
                and grew to over 100 employees, serving 2,500+ clients. Ray went
                on to co-found SnapNames.com. It was his first major role in the
                domain name space and they invented several new ways for people
                to acquire domain names; it grew to more than $49 million in
                annual revenue by 2006.
              </p>
              <p className="text-secondary-700 leading-relaxed mt-4" data-id="element-38">
                Ray has had a personal passion for wikis for years, which even
                led him to found ICANNWiki, a vibrant wiki resource that links
                together the ICANN ecosystem. He is a native and long-time
                resident of New York City, but has been in Portland Ore. since
                co-founding SnapNames.com – his current farm outside the city,
                complete with tractor and goats, is a definite but welcome
                departure from his days in Manhattan.He led Top Level Design in
                the application, acquisition, operation and sale of TLDs which
                include .design, .gay, .wiki, .ink and .tattoo. Currently, he is
                the CEO of Domain Name Registrar Porkbun.com.
              </p>
            </div>
          </div>
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-secondary-100 hover:shadow-2xl hover:scale-105 transition-all duration-300" data-id="element-39">
            <div className="w-full overflow-hidden flex justify-center bg-gradient-to-br from-secondary-50 to-primary-50/30 p-6" data-id="element-40">
              <img src="https://i.imgur.com/QlOma0J.jpg" alt="Marc Trachtenberg" className="object-contain max-h-80 rounded-lg" data-id="element-41" />
            </div>
            <div className="p-8" data-id="element-42">
              <h3 className="font-display text-3xl font-bold text-primary-700 mb-2" data-id="element-43">
                Marc Trachtenberg
              </h3>
              <p className="text-xl text-secondary-600 mb-6 font-medium" data-id="element-44">
                Principal
              </p>
              <p className="text-secondary-700 leading-relaxed" data-id="element-45">
                Marc has actively participated in ICANN for over 20 years and
                regularly advises some of the largest registries, registrars,
                e-commerce, social media, search engine, and other online
                platform providers. He participated in over 40 new gTLD
                applications in the first round of gTLD applications and has
                advised registries and registrars in the purchase and sale of
                their businesses, portfolios, and TLDs. He is also counsel to
                the Brand Registry Group which is the leading trade association
                for .Brand TLDs.
              </p>
              <p className="text-secondary-700 leading-relaxed mt-4" data-id="element-46">
                Based on his experience as a software consultant focused on
                enterprise class software-as-a-service offerings and obtaining
                the first ICANN-accreditation for a law-firm owned domain name
                registrar and running all aspects of the registrar business,
                Marc is well positioned to advise and assist domain name
                registrars, registries, and virtually all manner of online
                platforms and intermediaries including:
              </p>
              <ul className="list-disc pl-5 mt-4 space-y-2 text-secondary-700" data-id="element-47">
                <li data-id="element-48">ICANN compliance issues</li>
                <li data-id="element-49">Registry/Registrar agreements and policies</li>
                <li data-id="element-50">Platform policies and intellectual property issues</li>
                <li data-id="element-51">New gTLD applications and issues</li>
                <li data-id="element-52">Sale and acquisition of new gTLD registries</li>
                <li data-id="element-53">Co-promotion and other partnership programs</li>
                <li data-id="element-54">
                  Review, negotiation, and drafting of technology usage,
                  licensing, and development agreements
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}